import { createSelector } from 'reselect'
import { createMultipleStatusSelectors } from 'store/utils/selectorHelpers'
import types from './types'

const getElementsState = (state) => state.elements

export const selectElements = createSelector(
  [getElementsState],
  (elements) => elements.data
)

export const {
  selectFetchElementsStatus,
} = createMultipleStatusSelectors(types, getElementsState)



// WEBPACK FOOTER //
// ./src/store/elements/selectors.js